import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/ui/primitives';
import { PageShell } from '@/ui/layout';
import { ApiError } from '@/lib/api-client';
import { formatCPF, formatName } from '@/lib/format';
import { useCliente } from '@/modules/clientes/api';
import { decodeClienteId } from '@/modules/clientes/cliente-id';
import { ProdutividadeTable } from '@/modules/produtividade/components/ProdutividadeTable';

export const Route = createFileRoute('/_authed/clientes_/$id_/relatorio/produtividade')({
  component: ProdutividadeRoute,
});

function ProdutividadeRoute() {
  const navigate = useNavigate();
  const { id } = Route.useParams();
  const cpf = decodeClienteId(id);
  const { data: cliente, isLoading, error } = useCliente(cpf);

  const back = (
    <Button
      variant="ghost"
      onClick={() => {
        if (window.history.length > 1) window.history.back();
        else void navigate({ to: '/clientes/$id', params: { id }, search: { relatorio: undefined, tab: 'relatorios', from_pipe: undefined, from_grupo: undefined } });
      }}
    >
      <ArrowLeft size={14} strokeWidth={1.5} />
      Voltar ao cliente
    </Button>
  );

  if (isLoading) {
    return (
      <PageShell eyebrow="Relatórios" title="Histórico de Produtividade" back={back}>
        <p className="text-sm text-text-muted">Carregando…</p>
      </PageShell>
    );
  }

  if (error || !cliente) {
    return (
      <PageShell eyebrow="Relatórios" title="Histórico de Produtividade" back={back}>
        <p className="text-sm text-danger">
          {error instanceof ApiError ? error.message : 'Cliente não encontrado.'}
        </p>
      </PageShell>
    );
  }

  return (
    <PageShell
      eyebrow="Relatórios"
      title="Histórico de Produtividade"
      back={back}
      lead={`${formatName(cliente.nome)} · ${formatCPF(cliente.cpf)}`}
    >
      <ProdutividadeTable cpf={cliente.cpf} clienteId={Number(cliente.id)} />
    </PageShell>
  );
}
